import { useRef, useState, useEffect } from 'react';

const useProgress = (totalDuration) => {
    const milisecond = useRef(0);
    const [percentage, setPercentage] = useState(0);
    const [paused, setPause] = useState(true);
    const pauseTimestamp = useRef(null);
    useEffect(() => {
        if (totalDuration === 0)
            return;
        let startTimestamp;
        let handle;
        const resume = (timestampMs) => {
            if (!totalDuration)
                return;
            startTimestamp = timestampMs - milisecond.current;
            const step = (timestampMs) => {
                if (!paused || milisecond.current >= totalDuration) {
                    cancelAnimationFrame(handle);
                    return;
                }
                const elapsed = timestampMs - startTimestamp;
                milisecond.current = elapsed;
                if (milisecond.current >= totalDuration * 1000) {
                    setPercentage(100);
                    cancelAnimationFrame(handle);
                }
                else {
                    setPercentage((milisecond.current / totalDuration) * 100);
                    handle = requestAnimationFrame(step);
                }
            };
            handle = requestAnimationFrame(step);
        };
        const pause = () => {
            cancelAnimationFrame(handle);
        };
        if (paused) {
            startTimestamp = performance.now();
            resume(startTimestamp);
        }
        else {
            pause();
        }
        return () => {
            pauseTimestamp.current = performance.now();
            pause();
        };
    }, [paused, totalDuration]);
    return { percentage, setPause };
};

export { useProgress };
